import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    settingsOpened: false,
    themeBlack: Boolean(
      localStorage.getItem('pn_layout_dark') !== undefined
        ? localStorage.getItem('pn_layout_dark') == 'true'
        : window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches
    ),
    modal: {
      help: {
        show: false,
        title: 'Заголовок справки',
        subtitle: 'Справка',
        content: 'Контент',
      },
    },
  },
  mutations: {
    toggleSettings(state, value) {
      state.settingsOpened =
        !_.isUndefined(value) && _.isBoolean(value)
          ? value
          : !state.settingsOpened
    },
    toggleTheme(state, value) {
      state.themeBlack =
        !_.isUndefined(value) && _.isBoolean(value) ? value : !state.themeBlack
      localStorage.removeItem('darkThemeEnabled') // just remove old localstorage val
      localStorage.setItem('pn_layout_dark', String(state.themeBlack))
    },
    updateModal(state, { modal = 'help', show, title, content, subtitle }) {
      if (!_.isUndefined(show)) state.modal[modal].show = show
      if (!_.isUndefined(title)) state.modal[modal].title = title
      if (!_.isUndefined(content)) state.modal[modal].content = content
      if (!_.isUndefined(subtitle)) state.modal[modal].subtitle = subtitle
      else state.modal[modal].subtitle = 'Справка'
    },
  },
  actions: {
    updateAll({ dispatch, commit, rootState }, opts) {
      const dashboard = _.get(opts, 'dashboard', true)
      commit('market/update', { initialized: false }, { root: true })
      return Promise.all([
        dispatch('market/getPlatforms', null, { root: true }),
        dispatch('market/updateMarketInfo', null, { root: true }),
      ])
        .catch((err) => {
          console.log('Error while market/update', err)
        })
        .finally(() => {
          if (dashboard)
            return Promise.all([
              dispatch('market/updateTicker', null, { root: true }),
              dispatch(
                'request/getAllForTicker',
                {
                  ticker: rootState.market.ticker,
                  market: rootState.market.platform,
                },
                { root: true }
              ),
              // dispatch('market/updateLastDay', null, { root: true }),
              // dispatch('market/updateMetrics', null, { root: true }),
              dispatch('news/updateAll', null, { root: true }),
            ])
        })
    },
    showMessage(
      __,
      {
        type = 'warning',
        title = 'Title',
        message = 'Example message',
        timeout = 5000,
      }
    ) {
      if (window.__PRERENDER_INJECTED) {
        console.log('Prerendering, do not show messages')
        return
      }
      if (
        ['error', 'warning', 'success', 'info'].indexOf(type) == -1 ||
        !_.isString(title) ||
        !_.isString(message) ||
        !_.isNumber(timeout)
      ) {
        console.log('Wrong usage of layout/showMessage')
        return
      }
      return iziToast[type]({
        title,
        message,
        // zindex: 99999,
        layout: 1,
        balloon: false,
        close: true,
        closeOnEscape: false,
        rtl: false,
        position: 'bottomRight',
        timeout: timeout,
        animateInside: true,
        drag: true,
        pauseOnHover: true,
        resetOnHover: false,
        transitionIn: 'fadeInUp',
        transitionOut: 'fadeOut',
        transitionInMobile: 'fadeInUp',
        transitionOutMobile: 'fadeOutDown',
        buttons: {},
        inputs: {},
      })
    },
  },
  getters: {},
}
